import React, { Component } from "react";
import { FormGroup, Button, Label, Input } from "reactstrap";
import Select from "react-select";
import { connect } from "react-redux";
import axiosInstance from "../configuration/Request";
import Loader from "react-loaders";
import { setNetworkAnalysisDetails } from "../../reducers/counterSlice";
import backlogo from "../../assets/images/svg/Back.svg";
import { Link } from "react-router-dom";

const mapStateToProps = (state) => {
  return {
    reduxData: state.counterSlice,
  };
};

const mapDispatchToProps = {
  setNetworkAnalysisDetails,
};

class CreateNetwork extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: null,
      selectedDataSource: null,
      selectedSampleType: null,
      selectedRiskLevel: null,
      selectedTherapeuticResponse: null,
      selectedsubsampling_yes_no: "No",
      cancerTypeOptions: [],
      selectedCancerType: "true",
      selectedSourceGene: null,
      selectedTargetGene: null,
      loader: false,
      errorMessage: "",
      cancerTypeError: "",
      sourceGeneError: "",
      targetGeneError: "",
      dataSourceError: "",
      sampleTypeError: "",
      riskLevelError: "",
      therapeuticResponseError: "",
      dataSource: [],
      sampleType: [],
      riskLevel: [],
      therapeuticResponse: [],
      // Subscription-based access control
      userPlan: null,
      restrictedCancerTypes: [],
      restrictedDataSources: [],
      restrictedSampleTypes: [],
      restrictedRiskLevels: [],
      restrictedTherapeuticResponses: [],
    };
  }
  subsampling_yes_no = ["Yes", "No"];
  cancerTypeOptions = [{ lable: "Normal", value: "false" }, { lable: "Tumor", value: "true" }];
  drugTypeOptions = [
    "CNV",
    "mRNA",
    "Protein",
    "Mutation",
    "Fusion",
    "Methylation",
  ];

  componentDidMount() {
    this.setState({ loader: true });

    // Get user plan from Redux
    const userSubscription = this.props?.reduxData?.loginSubscriptionDetail;
    let userPlan = 'bronze'; // Default to bronze

    if (Array.isArray(userSubscription) && userSubscription.length > 0) {
      const activeSubscription = userSubscription.find(item => item.attributes?.active === true) || { id: 0 };
      userPlan = activeSubscription?.attributes?.plan?.toLowerCase() || 'bronze';
    }

    this.setState({ userPlan });

    const isBronzeUser = userPlan === 'bronze';

    // Restore existing details from Redux if available
    const details = this.props?.reduxData?.networkAnalysisDetails;
    if (details && Object.keys(details).length > 0) {
      this.setState({
        selectedSourceGene: details.source_gene || null,
        selectedTargetGene: details.target_gene || null,
        selectedCancerType: details.normal_tumor || "true",
        selectedsubsampling_yes_no: details.subsampling_yes_no === "yes" ? "Yes" : "No",
        selectedOption: details.histological_subtype || null,
      });
    }

    // Call main API for all users
    axiosInstance
      .get(`${process.env.REACT_APP_BASE_URL}api/network-dropdowns`)
      .then((res) => {
        const data = res?.data || {};
        const riskLevels = data?.riskLevels || [];

        const dataSourceOption = this.processDropdownOptions(data?.dataSources);
        const therapeuticResponseOption = this.processDropdownOptions(data?.therapeuticResponses);
        const sampleTypeOption = this.processDropdownOptions(data?.sampleTypes);
        const riskLevelOption = this.processRiskLevels(riskLevels);

        // For Bronze users, fetch restricted options
        if (isBronzeUser) {
          axiosInstance
            .get(`${process.env.REACT_APP_BASE_URL}api/network-dropdowns/filtered`)
            .then((filteredRes) => {
              const filteredData = filteredRes?.data || {};
              const restrictedCancerTypes = this.extractRestrictedCancerTypes(filteredData?.dropdownData);
              const restrictedDataSources = filteredData?.dataSources || [];
              const restrictedSampleTypes = filteredData?.sampleTypes || [];
              const restrictedRiskLevels = filteredData?.riskLevels || [];
              const restrictedTherapeuticResponses = filteredData?.therapeuticResponses || [];

              const cancerType = this.processCancerType(data?.dropdownData, restrictedCancerTypes);
              const dataSourceOption = this.processDataSourceOptions(data?.dataSources, restrictedDataSources, isBronzeUser);
              const sampleTypeOption = this.processDataSourceOptions(data?.sampleTypes, restrictedSampleTypes, isBronzeUser);
              const therapeuticResponseOption = this.processDataSourceOptions(data?.therapeuticResponses, restrictedTherapeuticResponses, isBronzeUser);
              const riskLevelOption = this.processRiskLevelOptions(riskLevels, restrictedRiskLevels, isBronzeUser);

              this.setState({
                cancerTypeOptions: cancerType,
                restrictedCancerTypes: restrictedCancerTypes,
                restrictedDataSources: restrictedDataSources,
                restrictedSampleTypes: restrictedSampleTypes,
                restrictedRiskLevels: restrictedRiskLevels,
                restrictedTherapeuticResponses: restrictedTherapeuticResponses,
                dataSource: dataSourceOption,
                sampleType: sampleTypeOption,
                riskLevel: riskLevelOption,
                therapeuticResponse: therapeuticResponseOption,
                selectedRiskLevel: this.getSelectedRiskLevel(riskLevelOption, details?.risk_level),
                selectedDataSource: this.getDefaultOption(dataSourceOption, "TCGA", details?.data_source),
                selectedSampleType: this.getDefaultOption(sampleTypeOption, "bulk tumor", details?.sample_type),
                selectedTherapeuticResponse: this.getDefaultOption(therapeuticResponseOption, "NA", details?.therapeutic_response),
                loader: false,
              });
            })
            .catch((err) => {
              console.log("Error fetching filtered data:", err);
              // Fallback: process without restrictions
              const cancerType = this.processCancerType(data?.dropdownData, []);
              this.setState({
                cancerTypeOptions: cancerType,
                dataSource: dataSourceOption,
                sampleType: sampleTypeOption,
                riskLevel: riskLevelOption,
                therapeuticResponse: therapeuticResponseOption,
                selectedRiskLevel: this.getSelectedRiskLevel(riskLevelOption, details?.risk_level),
                selectedDataSource: this.getDefaultOption(dataSourceOption, "TCGA", details?.data_source),
                selectedSampleType: this.getDefaultOption(sampleTypeOption, "bulk tumor", details?.sample_type),
                selectedTherapeuticResponse: this.getDefaultOption(therapeuticResponseOption, "NA", details?.therapeutic_response),
                loader: false,
              });
            });
        } else {
          // Silver/Gold users: no restrictions
          const cancerType = this.processCancerType(data?.dropdownData, []);

          this.setState({
            cancerTypeOptions: cancerType,
            dataSource: dataSourceOption,
            sampleType: sampleTypeOption,
            riskLevel: riskLevelOption,
            therapeuticResponse: therapeuticResponseOption,
            selectedRiskLevel: this.getSelectedRiskLevel(riskLevelOption, details?.risk_level),
            selectedDataSource: this.getDefaultOption(dataSourceOption, "TCGA", details?.data_source),
            selectedSampleType: this.getDefaultOption(sampleTypeOption, "bulk tumor", details?.sample_type),
            selectedTherapeuticResponse: this.getDefaultOption(therapeuticResponseOption, "NA", details?.therapeutic_response),
            loader: false,
          });
        }
      })
      .catch((err) => {
        console.log("Error fetching network dropdowns:", err);
        this.setState({ loader: false });
      });
  }

  // Helper function to extract restricted cancer types from filtered API
  extractRestrictedCancerTypes = (dropdownData) => {
    const restricted = [];
    if (!dropdownData) return restricted;

    dropdownData.forEach((item) => {
      if (item?.cancer_type && item?.histological_subtypes) {
        item.histological_subtypes
          .filter((subtype) => subtype !== null)
          .forEach((subtype) => {
            restricted.push({
              cancer_type: item.cancer_type,
              subtype: subtype,
            });
          });
      }
    });

    return restricted;
  };

  // Helper function to check if a cancer type option is restricted
  isRestrictedOption = (cancerType, subtype, restrictedList) => {
    return restrictedList.some(
      (item) => item.cancer_type === cancerType && item.subtype === subtype
    );
  };

  // Helper function to process cancer type dropdown
  processCancerType = (dropdownData, restrictedCancerTypes = []) => {
    return dropdownData?.filter((item) => item?.cancer_type).map((item) => ({
      label: item.cancer_type,
      options: item?.histological_subtypes
        ?.filter((subtype) => subtype !== null)
        .map((subtype) => {
          const isRestricted = this.isRestrictedOption(item.cancer_type, subtype, restrictedCancerTypes);
          return {
            value: subtype,
            label: subtype,
            cancer_type: item.cancer_type,
            isPremium: isRestricted,
            isDisabled: isRestricted,
          };
        }),
    })) || [];
  };

  // Helper function to process generic dropdown options
  processDropdownOptions = (data) => {
    return data?.filter((item) => item !== null).map((item) => ({
      value: item,
      label: this.capitalizeWords(item),
    })) || [];
  };

  // Helper function to process data source options with restrictions
  processDataSourceOptions = (data, restrictedSources = [], isBronze = false) => {
    return data?.filter((item) => item !== null).map((item) => {
      const isRestricted = isBronze && restrictedSources.includes(item);
      return {
        value: item,
        label: this.capitalizeWords(item),
        isPremium: isRestricted,
        isDisabled: isRestricted,
      };
    }) || [];
  };

  // Helper function to process risk levels
  processRiskLevels = (riskLevels) => {
    if (riskLevels.includes("all risk levels")) {
      return riskLevels
        .filter((item) => item !== null && item !== "NA")
        .map((item) => ({
          value: item,
          label: this.capitalizeWords(item),
        }));
    } else {
      return riskLevels
        .filter((item) => item !== null)
        .map((item) => ({
          value: item,
          label: item === "NA" ? "All Risk Levels" : this.capitalizeWords(item),
        }));
    }
  };

  // Helper function to process risk levels with restrictions
  processRiskLevelOptions = (riskLevels, restrictedLevels = [], isBronze = false) => {
    const isAllRestricted = isBronze && restrictedLevels.includes("all risk levels");

    if (riskLevels.includes("all risk levels")) {
      return riskLevels
        .filter((item) => item !== null && item !== "NA")
        .map((item) => ({
          value: item,
          label: this.capitalizeWords(item),
          isPremium: isAllRestricted || (isBronze && restrictedLevels.includes(item)),
          isDisabled: isAllRestricted || (isBronze && restrictedLevels.includes(item)),
        }));
    } else {
      return riskLevels
        .filter((item) => item !== null)
        .map((item) => {
          const isRestricted = isBronze && (restrictedLevels.includes(item) || (item === "NA" && restrictedLevels.includes("all risk levels")));
          return {
            value: item,
            label: item === "NA" ? "All Risk Levels" : this.capitalizeWords(item),
            isPremium: isRestricted,
            isDisabled: isRestricted,
          };
        });
    }
  };

  // Helper function to get the selected risk level
  getSelectedRiskLevel = (riskLevelOption, reduxValue = null) => {
    if (!riskLevelOption || riskLevelOption.length === 0) return null;

    // 1. Try to find the option matching the Redux value
    if (reduxValue) {
      const redVal = reduxValue?.value || reduxValue;
      const reduxOpt = riskLevelOption.find((opt) => opt.value === redVal);
      if (reduxOpt && !reduxOpt.isDisabled) return reduxOpt;
    }

    // Check "all risk levels" first
    const allRiskLevelsOpt = riskLevelOption.find(opt => opt.value === "all risk levels");
    if (allRiskLevelsOpt && !allRiskLevelsOpt.isDisabled) {
      return allRiskLevelsOpt;
    }

    // Check "NA" next
    const naOpt = riskLevelOption.find(opt => opt.value === "NA");
    if (naOpt && !naOpt.isDisabled) {
      return naOpt;
    }

    // Otherwise find first enabled
    return riskLevelOption.find(opt => !opt.isDisabled) || null;
  };

  // Helper function to get default selected option
  getDefaultOption = (options, defaultValue, reduxValue = null) => {
    if (!options || options.length === 0) return null;

    // 1. Try to find the option matching the Redux value (for restoring state)
    if (reduxValue) {
      const redVal = reduxValue?.value || reduxValue;
      const reduxOpt = options.find((opt) => opt.value === redVal);
      if (reduxOpt && !reduxOpt.isDisabled) {
        return reduxOpt;
      }
    }

    // 2. Find the option matching the default value
    const defaultOpt = options.find((opt) => opt.value === defaultValue);

    // If found and not disabled, use it
    if (defaultOpt && !defaultOpt.isDisabled) {
      return defaultOpt;
    }

    // If not found or disabled, find the first enabled option
    const firstEnabled = options.find((opt) => !opt.isDisabled);
    return firstEnabled || null;
  };

  capitalizeWords = (str) => {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  // Helper function to check if molecular type is enabled for Bronze users
  isMolecularTypeEnabled = (molecularType) => {
    const { userPlan } = this.state;

    // Silver/Gold users have access to all molecular types
    if (userPlan === 'silver' || userPlan === 'gold') {
      return true;
    }

    // Bronze users only have access to CNV and mRNA
    const enabledForBronze = ['CNV', 'mRNA'];
    return enabledForBronze.includes(molecularType);
  };

  // Custom option component for react-select with premium indicators
  CustomOption = (props) => {
    const { data, innerRef, innerProps } = props;
    const isDisabled = data.isDisabled || false;
    const isPremium = data.isPremium || false;

    return (
      <div
        ref={innerRef}
        {...innerProps}
        className={`custom-select-option ${isDisabled ? 'premium-option-disabled' : ''}`}
        style={{
          padding: '8px 30px',
          cursor: isDisabled ? 'not-allowed' : 'pointer',
          opacity: isDisabled ? 0.5 : 1,
          color: isDisabled ? '#999' : '#000',
          fontSize: '14px',
          backgroundColor: props.isFocused ? (isDisabled ? '#f5f5f5' : '#e3f2fd') : 'transparent',
          pointerEvents: isDisabled ? 'none' : 'auto',
        }}
        title={isPremium ? 'Available for Premium members only.' : ''}
      >
        {data.label}
        {isPremium && <span style={{ marginLeft: '8px' }}>🔒</span>}
      </div>
    );
  };

  handleSelectChange = (event, type) => {
    if (type === "cancer type") {
      this.setState({ selectedOption: event, cancerTypeError: "" });
    } else if (type === "data source") {
      this.setState({ selectedDataSource: event, dataSourceError: "" });
    } else if (type === "sample type") {
      this.setState({ selectedSampleType: event, sampleTypeError: "" });
    } else if (type === "risk level") {
      this.setState({ selectedRiskLevel: event, riskLevelError: "" });
    } else if (type === "therapeutic response") {
      this.setState({
        selectedTherapeuticResponse: event,
        therapeuticResponseError: "",
      });
    }
  };

  handleRadioChange = (value, type) => {
    if (type === "cancer") {
      this.setState({
        selectedCancerType: value,
      });
    } else if (type === "source") {
      this.setState({ selectedSourceGene: value, sourceGeneError: "" });
    } else if (type === "target") {
      this.setState({ selectedTargetGene: value, targetGeneError: "" });
    } else if (type === "subsampling_yes_no") {
      this.setState({ selectedsubsampling_yes_no: value });
    }
  };

  onSubmitClick = () => {
    let hasError = false;

    if (!this.state.selectedOption) {
      this.setState({ cancerTypeError: "Please select a Cancer Type." });
      hasError = true;
    }

    if (!this.state.selectedSourceGene) {
      this.setState({ sourceGeneError: "Please select a Source Gene." });
      hasError = true;
    }

    if (!this.state.selectedTargetGene) {
      this.setState({ targetGeneError: "Please select a Target Gene." });
      hasError = true;
    }
    if (!this.state.selectedSampleType) {
      this.setState({ sampleTypeError: "Please select a sample type." });
      hasError = true;
    }
    if (!this.state.selectedRiskLevel) {
      this.setState({ riskLevelError: "Please select a risk level." });
      hasError = true;
    }
    if (!this.state.selectedDataSource) {
      this.setState({ dataSourceError: "Please select a data source." });
      hasError = true;
    }
    if (!this.state.selectedTherapeuticResponse) {
      this.setState({
        therapeuticResponseError: "Please select a therapeutic response.",
      });
      hasError = true;
    }

    if (!hasError) {
      this.props.setNetworkAnalysisDetails({
        histological_subtype: {
          label: this.state.selectedOption.label,
          value: this.state.selectedOption.value,
        },
        cancer_type: this.state.selectedOption.cancer_type,
        source_gene: this.state.selectedSourceGene,
        target_gene: this.state.selectedTargetGene,
        normal_tumor: this.state.selectedCancerType,
        sample_type: this.state.selectedSampleType,
        risk_level: this.state.selectedRiskLevel,
        therapeutic_response: this.state.selectedTherapeuticResponse,
        subsampling_yes_no: this.state.selectedsubsampling_yes_no.toLowerCase(),
        data_source: this.state.selectedDataSource,
      });
      this.props.history.push("/app/discover/parameterSetting");
    }
  };

  render() {
    const {
      selectedOption,
      cancerTypeError,
      sourceGeneError,
      targetGeneError,
      therapeuticResponseError,
      riskLevelError,
      sampleTypeError,
      dataSourceError,
    } = this.state;

    return (
      <div className="outer-container">
        <div className="main-container">
          <div className="top-container">
            <Link
              className="btn-link-primary "
              to={{ pathname: "/app/discover/myProject" }}
            >
              <div className="d-inline-flex">
                <img src={backlogo} alt="" />
                <span
                  style={{ color: "#333333", fontWeight: 400 }}
                  className="ms-2"
                >
                  Back
                </span>
              </div>
            </Link>
            <div className="form-header">Network Analysis</div>
            <div className="network-form-container">
              <div>
                <FormGroup className="select-cancer-type ms-1 mt-1">
                  <Select
                    components={{ Option: this.CustomOption }}
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        height: "48px",
                        cursor: "pointer",
                        borderColor: cancerTypeError
                          ? "red"
                          : baseStyles.borderColor,
                      }),
                      option: (base) => ({
                        ...base,
                        cursor: "pointer",
                        fontSize: "14px",
                        paddingLeft: "30px",
                      }),
                      groupHeading: (base) => ({
                        ...base,
                        fontSize: "14px",
                        color: "#000000",
                      }),
                    }}
                    value={selectedOption}
                    onChange={(e) => this.handleSelectChange(e, "cancer type")}
                    options={this.state.cancerTypeOptions}
                    placeholder="Select a cancer type*"
                    isOptionDisabled={(option) => option.isDisabled}
                  />
                  <div className="error-message">
                    {cancerTypeError && (
                      <div className="text-danger mt-1">{cancerTypeError}</div>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="mt-1">
                <div className="row ms-1">
                  {this.cancerTypeOptions.map((option, index) => (
                    <div className="col-md-2 col-sm-4 col-6" key={index}>
                      <FormGroup check style={{ marginBottom: "0px" }}>
                        <Input
                          type="radio"
                          name="cancerType"
                          id={`cancer-radio-${index}`}
                          onChange={() =>
                            this.handleRadioChange(option.value, "cancer")
                          }
                          checked={this.state.selectedCancerType === option.value}
                          style={{ cursor: "pointer" }}
                        />
                        <Label
                          for={`cancer-radio-${index}`}
                          check
                          className="radio-label ml-2"
                        >
                          {option.lable}
                        </Label>
                      </FormGroup>
                    </div>
                  ))}
                </div>
                <div className="error-message ms-1"></div>
              </div>
              <hr style={{ width: "100%", marginTop: "4px" }} />
              <div className="drugType-header">Select Molecular Type</div>
              <div className="drug-type-container mb-2">
                <div className="source-gene-div">
                  <div className="gene-title">Source Gene*</div>
                  <div className="row ms-1">
                    {this.drugTypeOptions.map((label, index) => {
                      const isEnabled = this.isMolecularTypeEnabled(label);
                      const tooltipText = !isEnabled ? "Upgrade to Premium to unlock advanced molecular analysis." : "";

                      return (
                        <div
                          className="col-xl-3 col-lg-4 col-md-6 col-sm-3 col-6"
                          key={index}
                        >
                          <div
                            className={`radio-button-container ${!isEnabled ? 'molecular-type-disabled' : ''}`}
                            onClick={() => isEnabled && this.handleRadioChange(label, "source")}
                            title={tooltipText}
                            style={{
                              cursor: isEnabled ? 'pointer' : 'not-allowed',
                              opacity: isEnabled ? 1 : 0.5,
                            }}
                          >
                            <FormGroup check>
                              <Input
                                style={{ cursor: isEnabled ? "pointer" : "not-allowed" }}
                                type="radio"
                                name="sourceGene"
                                id={`source-radio-${index}`}
                                onChange={() => isEnabled && this.handleRadioChange(label, "source")}
                                checked={this.state.selectedSourceGene === label}
                                disabled={!isEnabled}
                              />
                              <Label
                                for={`source-radio-${index}`}
                                check
                                className="radio-label ml-2"
                                style={{
                                  color: isEnabled ? 'inherit' : '#999',
                                  cursor: isEnabled ? 'pointer' : 'not-allowed',
                                }}
                              >
                                {label}
                                {!isEnabled && <span style={{ marginLeft: '6px' }}>🔒</span>}
                              </Label>
                            </FormGroup>
                          </div>
                        </div>
                      );
                    })}
                    <div className="error-message">
                      {sourceGeneError && (
                        <div className="text-danger">{sourceGeneError}</div>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    borderLeft: "1px solid #c8c9cb",
                    height: "auto",
                    alignSelf: "stretch",
                    margin: "0 20px",
                  }}
                ></div>
                <div className="target-gene-div">
                  <div className="gene-title">Target Gene*</div>
                  <div className="row">
                    {this.drugTypeOptions.map((label, index) => {
                      const isEnabled = this.isMolecularTypeEnabled(label);
                      const tooltipText = !isEnabled ? "Upgrade to Premium to unlock advanced molecular analysis." : "";

                      return (
                        <div
                          className="col-xl-3 col-lg-4 col-md-6 col-sm-3 col-6"
                          key={index}
                        >
                          <div
                            className={`radio-button-container ${!isEnabled ? 'molecular-type-disabled' : ''}`}
                            onClick={() => isEnabled && this.handleRadioChange(label, "target")}
                            title={tooltipText}
                            style={{
                              cursor: isEnabled ? 'pointer' : 'not-allowed',
                              opacity: isEnabled ? 1 : 0.5,
                            }}
                          >
                            <FormGroup check>
                              <Input
                                style={{ cursor: isEnabled ? "pointer" : "not-allowed" }}
                                type="radio"
                                name="targetGene"
                                id={`target-radio-${index}`}
                                onChange={() => isEnabled && this.handleRadioChange(label, "target")}
                                checked={this.state.selectedTargetGene === label}
                                disabled={!isEnabled}
                              />
                              <Label
                                for={`target-radio-${index}`}
                                check
                                className="radio-label ml-2"
                                style={{
                                  color: isEnabled ? 'inherit' : '#999',
                                  cursor: isEnabled ? 'pointer' : 'not-allowed',
                                }}
                              >
                                {label}
                                {!isEnabled && <span style={{ marginLeft: '6px' }}>🔒</span>}
                              </Label>
                            </FormGroup>
                          </div>
                        </div>
                      );
                    })}
                    <div className="error-message">
                      {targetGeneError && (
                        <div className="text-danger">{targetGeneError}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <hr style={{ width: "100%", marginTop: "4px" }} />

              <div className="sections-container ">
                <div className="sections-inner ">
                  <div className="input-title">Data Source*</div>
                  <FormGroup className="create-select">
                    <Select
                      components={{ Option: this.CustomOption }}
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          height: "48px",
                          cursor: "pointer",
                          borderColor: dataSourceError
                            ? "red"
                            : baseStyles.borderColor,
                        }),
                        option: (base) => ({
                          ...base,
                          cursor: "pointer",
                          fontSize: "14px",
                          paddingLeft: "30px",
                        }),
                      }}
                      value={this.state.selectedDataSource}
                      onChange={(e) =>
                        this.handleSelectChange(e, "data source")
                      }
                      options={this.state.dataSource}
                      placeholder="Select Data Source..."
                      isOptionDisabled={(option) => option.isDisabled}
                    />
                    <div className="error-message">
                      {dataSourceError && (
                        <div className="text-danger mt-1">
                          {dataSourceError}
                        </div>
                      )}
                    </div>
                  </FormGroup>
                </div>
                <div className="sections-inner right-section">
                  <div className="input-title">Sample Type*</div>
                  <FormGroup className="create-select">
                    <Select
                      components={{ Option: this.CustomOption }}
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          height: "48px",
                          cursor: "pointer",
                          borderColor: sampleTypeError
                            ? "red"
                            : baseStyles.borderColor,
                        }),
                        option: (base) => ({
                          ...base,
                          cursor: "pointer",
                          fontSize: "14px",
                          paddingLeft: "30px",
                        }),
                      }}
                      value={this.state.selectedSampleType}
                      onChange={(e) =>
                        this.handleSelectChange(e, "sample type")
                      }
                      options={this.state.sampleType}
                      placeholder="Select Sample Type..."
                      isOptionDisabled={(option) => option.isDisabled}
                    />
                    <div className="error-message">
                      {sampleTypeError && (
                        <div className="text-danger mt-1">
                          {sampleTypeError}
                        </div>
                      )}
                    </div>
                  </FormGroup>
                </div>
              </div>

              <div className="sections-container">
                <div className="sections-inner">
                  <div className="input-title">Risk Level*</div>
                  <FormGroup className="create-select">
                    <Select
                      components={{ Option: this.CustomOption }}
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          height: "48px",
                          cursor: "pointer",
                          borderColor: riskLevelError
                            ? "red"
                            : baseStyles.borderColor,
                        }),
                        option: (base) => ({
                          ...base,
                          cursor: "pointer",
                          fontSize: "14px",
                          paddingLeft: "30px",
                        }),
                      }}
                      value={this.state.selectedRiskLevel}
                      onChange={(e) => this.handleSelectChange(e, "risk level")}
                      options={this.state.riskLevel}
                      placeholder="Select Risk Level ..."
                      isOptionDisabled={(option) => option.isDisabled}
                    />
                    <div className="error-message">
                      {riskLevelError && (
                        <div className="text-danger mt-1">{riskLevelError}</div>
                      )}
                    </div>
                  </FormGroup>
                </div>
                <div className="sections-inner right-section">
                  <div className="input-title">Therapeutic Response*</div>
                  <FormGroup className="create-select">
                    <Select
                      components={{ Option: this.CustomOption }}
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          height: "48px",
                          cursor: "pointer",
                          borderColor: therapeuticResponseError
                            ? "red"
                            : baseStyles.borderColor,
                        }),
                        option: (base) => ({
                          ...base,
                          cursor: "pointer",
                          fontSize: "14px",
                          paddingLeft: "30px",
                        }),
                      }}
                      value={this.state.selectedTherapeuticResponse}
                      onChange={(e) =>
                        this.handleSelectChange(e, "therapeutic response")
                      }
                      options={this.state.therapeuticResponse}
                      placeholder="Select Therapeutic Response..."
                      isOptionDisabled={(option) => option.isDisabled}
                    />
                    <div className="error-message">
                      {therapeuticResponseError && (
                        <div className="text-danger mt-1">
                          {therapeuticResponseError}
                        </div>
                      )}
                    </div>
                  </FormGroup>
                </div>
              </div>

              <div className="mt-3 mb-5">
                <div className="input-title">Subsampling*</div>
                <div className="row ms-1">
                  {this.subsampling_yes_no.map((label, index) => {
                    const isEnabled = !(this.state.userPlan === "bronze" && label === "Yes");
                    const tooltipText = !isEnabled ? "Upgrade to Premium to unlock subsampling features." : "";

                    return (
                      <div className="col-md-3 col-sm-4 col-6" key={index}>
                        <div
                          title={tooltipText}
                          style={{
                            cursor: isEnabled ? "pointer" : "not-allowed",
                            opacity: isEnabled ? 1 : 0.5,
                          }}
                        >
                          <FormGroup check style={{ marginBottom: "0px" }}>
                            <Input
                              type="radio"
                              name="subsampling_yes_no"
                              id={`subsampling_yes_no-radio-${index}`}
                              onChange={() =>
                                isEnabled && this.handleRadioChange(label, "subsampling_yes_no")
                              }
                              checked={this.state.selectedsubsampling_yes_no === label}
                              disabled={!isEnabled}
                              style={{ cursor: isEnabled ? "pointer" : "not-allowed" }}
                            />
                            <Label
                              for={`subsampling_yes_no-radio-${index}`}
                              check
                              className="radio-label ml-2"
                              style={{
                                color: isEnabled ? "inherit" : "#999",
                                cursor: isEnabled ? "pointer" : "not-allowed",
                              }}
                            >
                              {label}
                              {!isEnabled && <span style={{ marginLeft: "6px" }}>🔒</span>}
                            </Label>
                          </FormGroup>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          <div className="bottom-container">
            <Button
              className="next-button me-2"
              color="primary"
              onClick={this.onSubmitClick}
            >
              Next
            </Button>
          </div>
        </div>
        {this.state.loader && (
          <div className="backdrop">
            <div className="loader">
              <Loader type="ball-pulse-rise" />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateNetwork);
